import { render } from "./PanelSlider.vue?vue&type=template&id=472a7652"
import script from "./PanelSlider.vue?vue&type=script&lang=js"
export * from "./PanelSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__